import baseAPI from '@/api/base';
import { EditScreen, GetScreen, RegisterScreen, UpdateScreenLocation } from '@/dtos/screen.dto';
import {
  DELETE_SCREEN_URL,
  EDIT_SCREEN_URL,
  GET_SCREEN_URL,
  GET_SCREENS_UNPOPULATED_URL,
  REGISTER_SCREEN_URL,
  TOGGLE_SCREEN_IS_ACTIVE_URL,
  UPDATE_SCREEN_LOCATION_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Screen {
  static getScreens = async (getScreen: GetScreen): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_SCREEN_URL, {
      params: getScreen,
    });
    console.log('response', response);
    return response;
  };

  static getScreensUnpopulated = async (getScreen: GetScreen): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_SCREENS_UNPOPULATED_URL, {
      params: getScreen,
    });
    console.log('response', response);
    return response;
  };

  static registerScreen = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_SCREEN_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log('response', response);
    return response;
  };

  static editScreen = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_SCREEN_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  };

  static updateScreenLocation = async (
    updateScreenLocation: UpdateScreenLocation
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      UPDATE_SCREEN_LOCATION_URL,
      {
        ...updateScreenLocation,
      }
    );
    return response;
  };

  static toggleScreenIsActive = async (
    editScreen: EditScreen
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_SCREEN_IS_ACTIVE_URL,
      {
        ...editScreen,
      }
    );
    return response;
  };

  static deleteScreen = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_SCREEN_URL}/${userId}`
    );
    return response;
  };
}

export default Screen;
